// extracted by mini-css-extract-plugin
export default {"meals":"AvailableMeal_meals__Ezfxr","meals-appear":"AvailableMeal_meals-appear__D71uD"};